<template>
    <div class="content">
        <div class="message">
            Fehlende Berechtigung zur Anzeige des Presets.
        </div>
    </div>
</template>

<script>
    export default {
        name: "NoAccess"
    }
</script>

<style scoped>
    .content {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 500px;
    }

    .message {
        display: block;
        font-size: 1.5em;
        margin-block-start: 0.83em;
        margin-block-end: 0.83em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
        font-weight: bold;
    }

</style>